// Angular
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

// RxJS
import { Observable } from 'rxjs';

// Third-party
import { environment } from '@environment';

// Data Contracts
import { UserPermissionList } from '@data-contracts';

// Local
import { userManagementEndpoints } from '@app/types/api/endpoints/user-management.endpoints';

/**
 * Interface for the UserManagementApiService.
 */
export interface IUserManagementApiService {  
  getUserPermissions(): Observable<UserPermissionList>;  
}

/**
 * Base url for the api.
 */
const BASE_URL = environment.ApiServer.BaseURL;

/**
 * User Management Endpoints for the api.
 */
const USER_MANAGEMENT_ENDPOINTS = userManagementEndpoints(BASE_URL);

@Injectable({ providedIn: 'root' })
export class UserManagementApiService implements IUserManagementApiService {
  /**
   * The Angular HttpClient service used to make the API calls.
   */
  private readonly http = inject(HttpClient);

  /**
   * Endpoint to get user permissions.
   */
  getUserPermissions(): Observable<UserPermissionList> {
    const url = USER_MANAGEMENT_ENDPOINTS.getUserPermissions();    
    return this.http.get<UserPermissionList>(url);
  }

  
}
